import { useEffect, useState } from 'react';
import { FormControl, MenuItem, Select } from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
import nlflag from '../../Assets/nl.svg';
import enflag from '../../Assets/en.svg';
import deflag from '../../Assets/de.svg';
import esflag from '../../Assets/es.svg';
import frflag from '../../Assets/fr.svg';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';

const CustomIconComponent = (props: any) => (
  <FontAwesomeIcon icon={faCaretDown} size="sm" {...props} />
);

const LanguageDropdown = ({ style, className }: { style?: React.CSSProperties, className?: string }) => {
    const { i18n } = useTranslation();
    const [language, setLanguage] = useState(i18n.language.toUpperCase());
    const navigate = useNavigate();

    useEffect(() => {
        const pathSegments = window.location.pathname.split('/');
        const currentLang = pathSegments[1]?.toLowerCase();
        const validLanguages = ['nl', 'en', 'de', 'fr', 'es'];
        const storedLang = localStorage.getItem('preferredLanguage');

        if (validLanguages.includes(currentLang)) {
            if (currentLang !== i18n.language) {
                i18n.changeLanguage(currentLang).then(() => {
                    setLanguage(currentLang.toUpperCase());
                    localStorage.setItem('preferredLanguage', currentLang);
                });
            }
        } else if (storedLang && validLanguages.includes(storedLang) && storedLang !== i18n.language && storedLang !== 'null' && storedLang !== null && storedLang !== undefined) {
            i18n.changeLanguage(storedLang).then(() => {
                setLanguage(storedLang.toUpperCase());
            });
        } else {
            i18n.changeLanguage('nl').then(() => {
                setLanguage('nl'.toUpperCase());
            });
        }
    }, [i18n]);

    const changeLanguage = (event: SelectChangeEvent) => {
        const selectedLang = event.target.value?.toLowerCase() || 'nl';
        i18n.changeLanguage(selectedLang);
        setLanguage(selectedLang.toUpperCase());
        localStorage.setItem('preferredLanguage', selectedLang);

        const pathSegments = window.location.pathname.split('/');
        const currentLang = pathSegments[1]?.toLowerCase();

        if (currentLang !== selectedLang) {
            navigate(`/${selectedLang}${window.location.pathname.slice(3)}`);
        }
    };

    return (
        <FormControl style={style} className={className}>
            <Select
                labelId="language-select-label"
                id="language-select"
                value={language}
                onChange={changeLanguage}
                IconComponent={CustomIconComponent}
                sx={{
                    borderRadius: '0.4rem',
                    boxShadow: 'none',
                    padding: '0px',
                    '.MuiSelect-select': {
                        padding: '10px 0px 10px 10px',
                        marginRight: '-5px',
                        display: 'flex',
                        alignItems: 'center',
                    },
                    '.MuiSelect-icon': {
                        color: '#000',
                        marginRight: '3px',
                    },
                }}
            >
                <MenuItem value="NL" className='flex items-center justify-center'>
                    <img src={nlflag} alt="Dutch" className='w-[25px] h-[20px] rounded-md object-cover object-center' />
                </MenuItem>
                <MenuItem value="EN" className='flex items-center justify-center'>
                    <img src={enflag} alt="English" className='w-[25px] h-[20px] rounded-md object-cover object-center' />
                </MenuItem>
                <MenuItem value="DE" className='flex items-center justify-center'>
                    <img src={deflag} alt="German" className='w-[25px] h-[20px] rounded-md object-cover object-center' />
                </MenuItem>
                <MenuItem value="FR" className='flex items-center justify-center'>
                    <img src={frflag} alt="French" className='w-[25px] h-[20px] rounded-md object-cover object-center' />
                </MenuItem>
                <MenuItem value="ES" className='flex items-center justify-center'>
                    <img src={esflag} alt="Spanish" className='w-[25px] h-[20px] rounded-md object-cover object-center' />
                </MenuItem>
            </Select>
        </FormControl>
    );
};

export default LanguageDropdown;
